/* ═══════════════════════════════════════════════════════════════════
   APTUX WAY — Animated counter web component
   Counts from 0 to a target number when scrolled into view.

   Usage in Liquid:
     <aptux-counter data-end="900" data-suffix="+" data-duration="2000">0</aptux-counter>
   ═══════════════════════════════════════════════════════════════════ */

class AptuxCounter extends HTMLElement {
  connectedCallback() {
    this.end = parseInt(this.dataset.end || '0', 10);
    this.suffix = this.dataset.suffix || '';
    this.duration = parseInt(this.dataset.duration || '2000', 10);
    this.animated = false;

    // Don't animate if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.textContent = this.end + this.suffix;
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      this.animate();
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        observer.disconnect();
        this.animate();
      }
    }, { threshold: 0.3 });
    observer.observe(this);

    // Fallback: animate after 1.5s regardless
    setTimeout(() => {
      if (!this.animated) {
        observer.disconnect();
        this.animate();
      }
    }, 1500);
  }

  animate() {
    if (this.animated) return;
    this.animated = true;

    if (this.end === 0) {
      this.textContent = '0' + this.suffix;
      return;
    }

    const start = performance.now();
    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / this.duration, 1);
      // Ease-out cubic for nicer feel
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.floor(this.end * eased);
      this.textContent = value + this.suffix;
      if (progress < 1) requestAnimationFrame(tick);
      else this.textContent = this.end + this.suffix;
    };
    requestAnimationFrame(tick);
  }
}

if (!customElements.get('aptux-counter')) {
  customElements.define('aptux-counter', AptuxCounter);
}
